import { render } from "./RadioComponent.vue?vue&type=template&id=8e44883c&scoped=true&ts=true"
import script from "./RadioComponent?vue&type=script&lang=ts"
export * from "./RadioComponent?vue&type=script&lang=ts"

import "./_assets/_radio.scss?vue&type=style&index=0&id=8e44883c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e44883c"]])

export default __exports__